export default "__VITE_ASSET__vjwI0T0i__"